// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"352":"fc0c89af","412":"bcc3e4fa","453":"fce8e3b2"}[chunkId] + ".chunk.js";
};